module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logout-page"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))]), _vm._v(" "), (_vm.state == 'done') ? _c('router-link', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    attrs: {
      "to": {
        name: 'login'
      },
      "type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n().login) + "\n      ")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-828a02b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Logout.vue
// module id = 462
// module chunks = 0